/* ==========================================================================
 * KAAYU RITUAL ENGINE - shared recommendation algorithm
 *
 * SINGLE SOURCE OF TRUTH for how quiz answers map to product recommendations.
 *
 * Used by BOTH:
 *   assets/kaayu-quiz.js          (homepage quiz section)
 *   assets/kaayu-ritual-finder.js (the /pages/find-your-ritual page)
 *
 * These two were independent copies of the same 40 weighted rules. Changing a
 * weight in one and not the other would make the homepage quiz and the finder
 * page recommend different products for identical answers. They are unified
 * here so that cannot happen.
 *
 * Equivalence was proven before unifying: both original implementations were
 * run against all 32,768 answer permutations and returned identical rankings.
 *
 * Load order matters - this file must load BEFORE its two consumers.
 *
 * state shape: { q1:Set<symptom>, q2:severity, q3:dosha, q4:Set<lifestyle> }
 * returns    : product keys, highest scoring first
 ========================================================================== */

window.KaayuRitualEngine = (function () {
  function score(state){
    const symptoms  = [...state.q1];
    const dosha     = state.q3;
    const lifestyle = [...state.q4];
    const severity  = parseInt(state.q2)||3;
    const s={};
    const add=(k,v)=>{ s[k]=(s[k]||0)+v; };
    symptoms.forEach(c=>{
      if(c==='gut')      { add('happyGut',6);add('detoxTea',5);add('brownRice',2); }
      if(c==='sleep')    { add('wellNest',6);add('detoxTea',5);add('nightCream',3); }
      if(c==='hair')     { add('masazOil',6);add('loveSerum',5);add('wellNest',3);add('antiFlakey',3); }
      if(c==='skin')     { add('brownRice',6);add('elixir',5);add('nightCream',4);add('happyGut',3); }
      if(c==='immunity') { add('wellNest',6);add('detoxTea',5);add('happyGut',3); }
      if(c==='women')    { add('wellNest',6);add('happyGut',5);add('elixir',4);add('nightCream',3); }
    });
    if(dosha==='vata')  { add('wellNest',2);add('masazOil',2);add('nightCream',2); }
    if(dosha==='pitta') { add('happyGut',2);add('detoxTea',2);add('brownRice',2); }
    if(dosha==='kapha') { add('wellNest',2);add('detoxTea',2); }
    if(lifestyle.includes('stress'))     { add('wellNest',3);add('detoxTea',2); }
    if(lifestyle.includes('diet'))       { add('happyGut',3);add('detoxTea',2); }
    if(lifestyle.includes('sleep_depri')){ add('wellNest',3);add('nightCream',2); }
    if(lifestyle.includes('pollution'))  { add('antiFlakey',2);add('brownRice',2); }
    if(lifestyle.includes('hormonal'))   { add('wellNest',3);add('happyGut',2);add('elixir',2); }
    if(severity>=4) Object.keys(s).forEach(k=>s[k]++);
    return Object.entries(s).sort((a,b)=>b[1]-a[1]).map(e=>e[0]);
  }

  return { score: score };
})();
